// hooks
import { useSelector } from 'hooks';

// stores
import { usePickedRosterPlanMode } from '../RosterPlan.stores';

// types
import type { RootState } from 'redux/rootReducer';

// utils
import { getAvailableRosterPlanModes } from '../utils/getAvailableRosterPlanModes';
import { resolveRosterPlanMode } from '../utils/resolveRosterPlanMode';

/** The mode the screen is in, and the modes the planner's grants allow switching to. */
const useRosterPlanMode = () => {
  const grants = useSelector((state: RootState) => state.grants);
  const pickedMode = usePickedRosterPlanMode();

  return {
    mode: resolveRosterPlanMode(pickedMode, grants),
    availableModes: getAvailableRosterPlanModes(grants)
  };
};

export default useRosterPlanMode;
